/**
 * Offer Request Dialog Store
 * Zustand store to open/close the offer request dialog from anywhere
 */

import { create } from 'zustand';

interface OfferRequestDialogState {
  /** Whether the offer request dialog is open */
  isOpen: boolean;
  /** The request ID of the analysis the dialog was opened from */
  requestId: string | undefined;
  /** Open the dialog, optionally with a request ID */
  open: (requestId?: string) => void;
  /** Close the dialog */
  close: () => void;
}

export const useOfferRequestDialogStore = create<OfferRequestDialogState>((set) => ({
  isOpen: false,
  requestId: undefined,
  open: (requestId?: string) => set({ isOpen: true, requestId }),
  close: () => set({ isOpen: false, requestId: undefined }),
}));
